import { type VariantProps, cva } from 'class-variance-authority';

export const textAreaStyles = cva(
  [
    'text-area',
    'text-black text-body-responsive placeholder:text-grey-700',
    'bg-white',
    'border',
    'rounded-[6px]',
    'focus:outline-none',
    'min-h-[100px]',
    'focus:outline-none',
    'focus:border-blue-300 focus:border',
  ],
  {
    variants: {
      intent: {
        primary: ['px-[12px]', 'py-[10px]', 'h-[44px]', 'border-grey-400'],
        search: ['py-[8px]', 'pr-[16px]', 'pl-[38px]', 'h-[40px]', 'border-grey-400'],
        secondary: ['px-[12px]', 'py-[10px]', 'h-[44px]', 'border-blue-300'],
        old: [
          'px-[16px]',
          'py-[22px]',
          '!bg-[#f5f5f5]',
          'border-none',
          '!text-[14px]',
          '!font-light',
          '!text-[#757575]',
          '!font-trade-pro',
        ],
      },
      size: {
        full: ['w-full'],
        flexible_height: ['!h-auto w-full'],
        tall: ['!h-66 w-full'],
      },
      error: {
        false: null,
        true: ['border-red-500'],
      },
      disableResize: {
        false: null,
        true: ['resize-none'],
      },
      withCounter: {
        false: null,
        true: ['!border-0 !rounded-b-none !rounded-t-[6px]'],
      },
      disabled: {
        false: null,
        true: [
          'disabled:cursor-not-allowed',
          'disabled:bg-grey-100',
          'disabled:border-grey-400',
          'disabled:placeholder:text-neutral-700',
        ],
      },
    },
    defaultVariants: {
      disabled: false,
      intent: 'primary',
      size: 'full',
    },
  }
);

export const labelStyles = cva(['label', 'mb-2', 'block'], {
  variants: {
    required: {
      true: ['after:content-["*"] after:text-red-500'],
      false: null,
    },
    intent: {
      primary: ['text-body-responsive', 'text-blue-900'],
      small: ['text-body-small', 'text-blue-900'],
      old: ['text-tp-body-small', 'text-blue-700', 'text-left', 'mb-3'],
    },
  },
  defaultVariants: {
    intent: 'primary',
  },
});

export const textAreaErrorMessageStyles = cva(['text-red-500', 'text-body-small'], {
  variants: {
    position: {
      absolute: ['absolute', 'bottom-[-21px]', 'mt-[6px]'],
      relative: ['relative', 'mt-[6px]', 'pb-[6px]'],
    },
  },
  defaultVariants: {
    position: 'absolute',
  },
});

export type LabelVariantsProps = VariantProps<typeof labelStyles>;
export type TextAreaVariantsProps = VariantProps<typeof textAreaStyles>;
export type TextAreaErrorMessageVariantsProps = VariantProps<typeof textAreaErrorMessageStyles>;
